"use strict";

exports.__esModule = true;
exports.BlockRenderer = void 0;

var _react = _interopRequireWildcard(require("react"));

var _react2 = require("@chakra-ui/react");

var _RendererContext = require("./RendererContext");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var __jsx = _react["default"].createElement;

var BlockRenderer = function BlockRenderer(_ref) {
  var block = _ref.block;

  var _useContext = (0, _react.useContext)(_RendererContext.RendererContext),
      tools = _useContext.tools;

  var tool = (0, _react.useMemo)(function () {
    var tool = {
      component: function component(_ref2) {
        var block = _ref2.block;
        return __jsx(_react2.Box, null, "Unsuported block (type: ", block.type, ")");
      }
    };

    for (var i = 0; i < tools.length; i++) {
      var _tool = tools[i];

      if (block.type === _tool.block.type) {
        tool = _tool;
        break;
      }
    }

    return tool;
  }, [tools, block.type]);
  return __jsx(tool.component, {
    block: block
  });
};

exports.BlockRenderer = BlockRenderer;
BlockRenderer.displayName = "BlockRenderer";